import { render, staticRenderFns } from "./pulsera.vue?vue&type=template&id=b763ba00&scoped=true"
import script from "./pulsera.vue?vue&type=script&lang=js"
export * from "./pulsera.vue?vue&type=script&lang=js"
import style0 from "./pulsera.vue?vue&type=style&index=0&id=b763ba00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763ba00",
  null
  
)

export default component.exports